import { type AllStatuses, WorkflowSummary } from '@opallabs/concepts'

/**
 * The workflow mark a content status has earned.
 *
 * Content carries the v3 workflow vocabulary (`for_approval`,
 * `needs_revision`) and the shared icon set speaks in approval states, so the
 * two are matched here and nowhere else: the grid puts these marks on a chip
 * and the filter drawer puts them on the row that will keep it, and a person
 * reading both has to see one mark for one state.
 *
 * Keys are the status a content item carries, not the id the drawer offers it
 * under. A status with no entry — a workspace with statuses of its own — gets
 * no mark, which says less than a wrong one.
 */
export const CALENDAR_CONTENT_STATUS_MARKS: Readonly<
  Record<string, AllStatuses>
> = {
  approved: 'approval-approved',
  draft: 'approval-not-sent',
  for_approval: 'approval-pending',
  idea: 'not-started',
  needs_revision: 'approval-denied',
  published: 'published',
}

/**
 * The workflow mark a moment has earned, by the summary of the workflow over
 * it. These are the marks the drawer puts beside the moment half of its status
 * list, so a moment's bar, its row in the panel and the option that keeps it
 * all wear one shape for one state.
 */
export const CALENDAR_MOMENT_SUMMARY_MARKS: Readonly<
  Record<WorkflowSummary, AllStatuses>
> = {
  [WorkflowSummary.Approved]: 'approval-approved',
  [WorkflowSummary.Declined]: 'approval-denied',
  [WorkflowSummary.NotStarted]: 'not-started',
  [WorkflowSummary.Paused]: 'paused',
  [WorkflowSummary.PendingApproval]: 'approval-pending',
  [WorkflowSummary.PendingTasks]: 'tasks-pending',
  [WorkflowSummary.TasksComplete]: 'tasks-complete',
}
